import AccountMixin from '@/store/module/account/mixin'
import CompanyMixin from '@/store/module/company/mixin'
import DocMixin from '../../mixins/DocMixin'
import PCIRepository from '@/shared/http/repositories/pci/pci'
import GedFileRepository from '@/shared/http/repositories/business/gedfile'
import GedFolderRepository from '@/shared/http/repositories/business/gedfolder'
import { loading, toast } from '@/shared/utils/UIHelper'

export default {
  name: 'FileSelection',
  components: {
    PCIRepository,
    loading,
    GedFileRepository
  },
  data () {
    return {
      currentFolder: null,
      title: '',
      // Picker: última pasta vinculada nesta aba (sessionStorage) + contador que remonta o iframe a cada abertura.
      ultimaPastaId: null,
      openSeq: 0
    }
  },
  mixins: [DocMixin, AccountMixin, CompanyMixin],
  props: {
    startupFolderId: {
      type: String,
      default: null
    }
  },
  computed: {
    // URL do ZDocs embarcado no iframe. Viewer (startupFolderId) abre direto na pasta;
    // sem startupFolderId = modo picker (escolher pasta pra vincular na obra).
    zdocsUrl () {
      const base = process.env.ZDocsURL
      if (!base) return ''
      const params = []
      const empresaId = this.company && this.company.id
      if (empresaId) params.push(`empresaId=${encodeURIComponent(empresaId)}`)
      if (this.startupFolderId) params.push(`pastaId=${encodeURIComponent(this.startupFolderId)}`)
      else {
        params.push('picker=1')
        // ZDocs abre a árvore expandida até a última pasta vinculada, já selecionada.
        if (this.ultimaPastaId) params.push(`pastaId=${encodeURIComponent(this.ultimaPastaId)}`)
      }
      return `${base}/#/documentos?${params.join('&')}`
    },
    // sessionStorage (não localStorage): escopo por aba — duas PCIs abertas não se atropelam.
    ultimaPastaKey () {
      const empresaId = this.company && this.company.id
      return `PciZdocsUltimaPasta:${empresaId || ''}`
    }
  },
  mounted () {
    window.addEventListener('message', this.onZdocsMessage)
  },
  beforeDestroy () {
    window.removeEventListener('message', this.onZdocsMessage)
  },
  methods: {
    // Recebe a pasta selecionada dentro do iframe do ZDocs (modo picker).
    onZdocsMessage (event) {
      const data = event && event.data
      if (!data || data.source !== 'zdocs') return
      try {
        if (process.env.ZDocsURL && event.origin !== new URL(process.env.ZDocsURL).origin) return
      } catch (e) { /* base malformada — segue só com o source */ }
      if (data.type === 'folder-selected' && data.folder) {
        this.currentFolder = data.folder
      } else if (data.type === 'folder-cleared') {
        this.currentFolder = null
      }
    },
    onSelectFolder (folder) {
      this.currentFolder = folder
    },
    closeModalGed () {
      this.$refs.gedModal.hide()
    },
    openModalGed () {
      this.currentFolder = null
      if (!this.startupFolderId) {
        try { this.ultimaPastaId = window.sessionStorage.getItem(this.ultimaPastaKey) } catch (e) { this.ultimaPastaId = null }
        this.openSeq++
      }
      this.$refs.gedModal.show()
    },
    folderSelected () {
      if (!this.currentFolder) return
      loading.push()
      GedFolderRepository.Get(this.currentFolder.id)
        .then(response => {
          if (response.data.data.status === -1) {
            toast.warning(this.$lang.PCI.Documents.WarningDeletedFoldersSelected)
          } else {
            this.closeModalGed()
            try { window.sessionStorage.setItem(this.ultimaPastaKey, this.currentFolder.id) } catch (e) { /* storage bloqueado — só não lembra */ }
            this.$emit('on-selected-folder', this.currentFolder)
          }
        })
        .catch(err => {
          this.onException(err)
        }).finally(() => loading.close())
    },
    onHide () {
      this.$emit('hide')
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/documents/components/folderselection/fileselection.js